import { useNavigate } from 'react-router-dom';
import { FaYoutube, FaFacebook, FaHome, FaAppStore } from 'react-icons/fa';
import { SiGoogleplay, SiApple } from 'react-icons/si';
import { getHomeFeed, getChannels, getPages, getLiveBroadcasts } from '../api/publicApi';
import useFetch from '../hooks/useFetch';
import { useMemo } from 'react';

const LEFT_LINKS = [
  { to: '/representations', label: 'NOS REPRÉSENTATION DANS LE MONDE' },
  { to: '/semence', label: 'LA SEMENCE MATINALE' },
  { to: '/motivation', label: 'LES LUNDIS DE LA MOTIVATION' },
  { to: '/evenements', label: 'NOS ÈVÉNEMENTS', active: true },
  { to: '/directs', label: 'NOS DIRECTS', showLiveBadge: true },
];
const RIGHT_LINKS = [
  { to: '/enseignements', label: 'NOS ENSEIGNEMENTS' },
  { to: '/prieres', label: 'PRIÈRES' },
  { to: '/temoignages', label: 'TÉMOIGNAGES' },
  { to: '/canaux', label: 'NOS CANAUX DE COMMUNICATION' },
  { to: '/contact', label: 'NOUS CONTACTER' },
];

/* Strip HTML tags and return plain text preview of n chars */
function htmlPreview(html = '', n = 100) {
  const plain = html.replace(/<[^>]+>/g, ' ').replace(/\s+/g, ' ').trim();
  return plain.length > n ? plain.slice(0, n).trimEnd() + '…' : plain;
}

export default function HomePage() {
  const navigate = useNavigate();
  const { data } = useFetch(getHomeFeed, null, []);
  const { data: channelsData } = useFetch(getChannels, { limit: 20, statut: 'active' }, []);
  const { data: pagesData, loading: pagesLoading } = useFetch(getPages, { limit: 100, statut: 'publie' }, []);
  const { data: liveData } = useFetch(getLiveBroadcasts, null, []);

  const quote = data?.data?.today_quote;
  const announceText = quote?.valeur || '« Jésus, j\'ai confiance en Toi »';

  const pages = pagesData?.data || [];
  const channels = channelsData?.data || [];

  // Check if there's a live broadcast
  const liveList = useMemo(() => liveData?.data ?? [], [liveData]);
  const liveBroadcast = liveList.find(b => b.is_live) ?? liveList[0] ?? null;
  const isLive = !!liveBroadcast;

  return (
    <div style={{ display: 'flex', flexDirection: 'column', height: '100vh' }}>
      {/* Desktop topbar */}
      <header className="user-topbar desktop-topbar">
        <div style={{ width: 60 }} />
        <a className="brand" href="/" onClick={e => { e.preventDefault(); navigate('/'); }}>
          <img src="/logo182.png" alt="MCM" />
          <span>MINISTÈRE CATHOLIQUE MISERICORDE</span>
        </a>
        <div style={{ width: 60 }} />
      </header>

      {/* Mobile topbar */}
      <header className="mobile-topbar">
        <div style={{ width: 36 }} />
        <span className="mobile-topbar-title">MCM</span>
        <div style={{ width: 36 }} />
      </header>

      {/* Announce bar */}
      <div className="announce-bar pt-0">{announceText}</div>

      <div style={{ flex: 1, overflowY: 'auto' }} className="invisible-scrollbar">
        <div className="home-hero-bg">
          <section className="home-hero">
            <div className="home-nav-links w-100">
              {LEFT_LINKS.map(l => (
                <button
                  key={l.to}
                  className={`home-nav-link ${l.showLiveBadge && isLive ? 'has-live-badge' : ''}`}
                  onClick={() => navigate(l.to)}
                >
                  <span>{l.label}</span>
                  {/* {l.showLiveBadge && isLive ? (
                    <span style={{
                      position: 'absolute',
                      right: '16px',
                      top: '26%',
                      transform: 'translateY(-50%)',
                      display: 'inline-flex',
                      alignItems: 'center',
                      gap: '6px',
                      background: '#e00',
                      color: '#fff',
                      fontSize: '10px',
                      fontWeight: 800,
                      letterSpacing: '1.2px',
                      textTransform: 'uppercase',
                      padding: '4px 10px',
                      borderRadius: '4px',
                      animation: 'pulse-live 2s ease-in-out infinite',
                      boxShadow: '0 0 10px rgba(255,0,0,0.5)',
                    }}>
                      <span style={{
                        width: '6px',
                        height: '6px',
                        borderRadius: '50%',
                        background: '#fff',
                        animation: 'blink-dot 1.5s ease-in-out infinite',
                      }} />
                      En direct
                    </span>
                  ) : (
                    <span className="arrow"></span>
                  )} */}
                   {l.showLiveBadge && isLive ? (
                  <span style={{
                    display: 'inline-flex',
                    alignItems: 'center',
                    gap: '6px',
                    background: '#e00',
                    color: '#fff',
                    fontSize: '10px',
                    fontWeight: 800,
                    letterSpacing: '1.2px',
                    textTransform: 'uppercase',
                    padding: '4px 10px',
                    borderRadius: '4px',
                    animation: 'pulse-live 2s ease-in-out infinite',
                    boxShadow: '0 0 10px rgba(255,0,0,0.5)',
                  }}>
                    <span style={{
                      width: '6px',
                      height: '6px',
                      borderRadius: '50%',
                      background: '#fff',
                      animation: 'blink-dot 1.5s ease-in-out infinite',
                    }} />
                    En direct
                  </span>
                ) : (
                  <span className="arrow">↗</span>
                )}
                </button>
              ))}
            </div>
            <div style={{ display: 'flex', justifyContent: 'center' }}>
              <img src="/logo192.png" alt="MCM" className="home-logo" />
            </div>
            <div className="home-nav-links w-100">
            {RIGHT_LINKS.map(l => (
              <button key={l.to} className="home-nav-link" onClick={() => navigate(l.to)}>
                <span>{l.label}</span>
                <span className="arrow">↗</span>
              </button>
            ))}
          </div>
          </section>
        </div>

        <section className="home-cards">
          {pagesLoading ? (
            Array.from({ length: 3 }).map((_, i) => (
              <div key={i} className="info-card" style={{ opacity: 0.4 }}>
                <div className="info-card-tag" style={{ background: '#eee', width: 60, height: 14, borderRadius: 4 }} />
                <h3 style={{ background: '#eee', height: 20, borderRadius: 4, marginTop: 12 }} />
                <div className="info-card-line" />
                <p style={{ background: '#eee', height: 60, borderRadius: 4 }} />
              </div>
            ))
          ) : pages.length > 0 ? (
            pages.map(p => (
              <div key={p.id} className="info-card">
                <div className="info-card-tag">{p.slug.split('-').slice(-1)[0].toUpperCase()}</div>
                <h3>{p.titre}</h3>
                <div className="info-card-line" />
                <p>{htmlPreview(p.contenu, 58)}</p>
                <a
                  href={`/pages/${p.slug}`}
                  className="info-card-link"
                  onClick={e => { e.preventDefault(); navigate(`/pages/${p.slug}`); }}
                >
                  EN SAVOIR PLUS →
                </a>
              </div>
            ))
          ) : null}
        </section>
      </div>

      <footer className="user-footer d-md-flex d-none align-items-center justify-content-between" style={{ borderTop: '1px solid #eee' }}>
        <div style={{ display: 'flex', alignItems: 'center', gap: 16 }}>
          <span>© {new Date().getFullYear()} Ministère Catholique Miséricorde — MCM. Tous droits réservés.</span>
          <span style={{ color: '#ddd' }}>|</span>
          <a
            href="/privacy-policy"
            onClick={(e) => { e.preventDefault(); navigate('/privacy-policy'); }}
            style={{ fontSize: 12, color: '#666', textDecoration: 'none', transition: 'color 0.2s' }}
            onMouseEnter={(e) => e.target.style.color = '#8b1512'}
            onMouseLeave={(e) => e.target.style.color = '#666'}
          >
            Politique de confidentialité
          </a>
          <span style={{ color: '#ddd' }}>|</span>
          <a
            href="/terms-conditions"
            onClick={(e) => { e.preventDefault(); navigate('/terms-conditions'); }}
            style={{ fontSize: 12, color: '#666', textDecoration: 'none', transition: 'color 0.2s' }}
            onMouseEnter={(e) => e.target.style.color = '#8b1512'}
            onMouseLeave={(e) => e.target.style.color = '#666'}
          >
            Conditions d'utilisation
          </a>
        </div>

        <div className="footer-social">
          <span style={{ fontSize: 12, fontWeight: 600 }}>NOUS SUIVRE:</span>
          <a href={'https://www.youtube.com/@BergerElyseeDossaenprier-pe4re'} target="_blank" rel="noreferrer" title="YouTube"><FaYoutube color='#8b1512' /></a>
          <a href={'https://www.facebook.com/MCMisericorde'} target="_blank" rel="noreferrer" title="Facebook"><FaFacebook color='#8b1512' /></a>
          {/* <a 
            href="https://play.google.com/store/apps/details?id=com.ministeremc" 
            target="_blank" 
            rel="noreferrer"
            title="Google Play Store"
          >
            <SiGoogleplay color='#8b1512' size={18}/>
          </a> */}
          <a 
            href="https://apps.apple.com/us/app/minist%C3%A8re-catho-mis%C3%A9ricorde/id6801453231" 
            target="_blank" 
            rel="noreferrer"
            title="Apple App Store"
          >
            <FaAppStore color='#8b1512' size={18}/>
          </a>
        </div>
      </footer>
    </div>
  );
}
